(function () {
    'use strict';

    function excludeSelectedApplicants() {
        return function (items, applicants) {
            var allApplicantIds = _.map(applicants, (function (applicant) {
                return applicant.Id;
            }));

            var filteredData = [];
            angular.forEach(items, function (item) {
                if (!(_.include(allApplicantIds, item.Id))) {
                    filteredData.push(item);
                }
            });
            return filteredData;
        };
    }

    angular.module('ecap.common').filter('excludeSelectedApplicants', excludeSelectedApplicants);
})();